import { CHARACTER_WHITESPACE } from '../../../../../constants/common'
import {
  getIsListingArchivable,
  getListingUnitLabel,
} from '../../../../RentalPortalListing'
import { getListingsLivePublicationCount } from '../../RentalPortalListings.utils'

function getListingsMassActionActSentence({ eligibleItems, t }) {
  return eligibleItems.length === 1
    ? t('RentalPortal.ListingArchiveConfirmationTextKey', {
        name: getListingUnitLabel({ listing: eligibleItems[0], t }),
      })
    : t('RentalPortal.ListingArchiveMassConfirmationTextKey', {
        count: eligibleItems.length,
      })
}

export function getListingsMassActionItems({
  excludeIds,
  items,
  selectAllPages,
  selected,
}) {
  return selectAllPages
    ? items.filter(listing => !excludeIds.includes(listing.id))
    : selected
}

export function getListingsMassActionEligibleItems(items) {
  return items.filter(getIsListingArchivable)
}

export function getListingsMassActionDescription({
  eligibleItems,
  selectedCount,
  t,
}) {
  const livePublicationCount = getListingsLivePublicationCount(eligibleItems)

  const sentences = [
    getListingsMassActionActSentence({ eligibleItems, t }),
    eligibleItems.length < selectedCount
      ? t('RentalPortal.ListingArchiveMassMixedEligibilityKey', {
          eligible: eligibleItems.length,
          selected: selectedCount,
        })
      : null,
    livePublicationCount > 0
      ? t('RentalPortal.ListingArchiveMassLivePortalsWarningKey', {
          count: livePublicationCount,
        })
      : null,
  ]

  return sentences.filter(Boolean).join(CHARACTER_WHITESPACE)
}
